module.exports = __webpack_public_path__ + "static/img/qrCode_DEV.84dae0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qrCode/qrCode_DEV.png
// module id = Aq1B
// module chunks = 1